export const FLOOR_SLIDE_ITEM_MAX_COUNT = 5;
